module.exports = __webpack_public_path__ + "static/technicolor-d949ae99e37b7e8cd02ec06a4adff7ea.svg";